import '../components/styling/footer.scss';


export default function Footer() {
  return (
    <footer id="footer">
      Copyright © 2023 Serendipity Creative Writers | Website created by
      <a className="footerLink" href="https://yuvalzoref.com" rel="noreferrer" target="blank"> Yuval Zoref</a>
    </footer>
  )
}
